<template>
  <div class="loan-container">

    <h2 class="title">Create New Loan</h2>

    <form @submit.prevent="createLoan" class="loan-form">

      <!-- Client -->
      <div class="form-group">
        <label>Select Client</label>
        <select v-model="form.client_id" required>
          <option value="">Select client</option>
          <option
            v-for="client in clients"
            :key="client.id"
            :value="client.id"
          >
            {{ client.client_name }} (Limit: {{ formatMoney(client.loan_limit) }})
          </option>
        </select>
      </div>

      <!-- Loan Amount -->
      <div class="form-group">
        <label>Loan Amount</label>
        <input
          type="number"
          v-model="form.loan_amount"
          required
        />
      </div>

      <!-- Pay Date -->
      <div class="form-group">
        <label>Pay Date (1–31)</label>
        <input
          type="number"
          min="1"
          max="31"
          v-model="form.pay_date"
          required
        />
      </div>

      <!-- Date Issued -->
      <div class="form-group">
        <label>Date Issued</label>
        <input
          type="date"
          v-model="form.date_issued"
          required
        />
      </div>

      <!-- Submit -->
      <button type="submit" :disabled="loading">
        {{ loading ? "Creating..." : "Create Loan" }}
      </button>

    </form>

    <!-- Success -->
    <div v-if="successMessage" class="success">
      {{ successMessage }}
    </div>

    <!-- Error -->
    <div v-if="errorMessage" class="error">
      {{ errorMessage }}
    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoanCreate",

  data() {
    return {
      clients: [],
      loading: false,

      form: {
        client_id: "",
        loan_amount: "",
        pay_date: "",
        date_issued: ""
      },

      successMessage: "",
      errorMessage: ""
    };
  },

  mounted() {
    this.fetchClients();
  },

  methods: {

    async fetchClients() {
      try {

        const response = await axios.get(
          "https://api.roberms.com/raisetrack/get/loan/clients"
        );

        this.clients = response.data;

      } catch (error) {
        console.error(error);
      }
    },

    async createLoan() {

      this.loading = true;
      this.successMessage = "";
      this.errorMessage = "";

      try {

        const response = await axios.post(
          "https://api.roberms.com/raisetrack/create-loan",
          this.form
        );

        this.successMessage = response.data.message;

        // Reset form
        this.form = {
          client_id: "",
          loan_amount: "",
          pay_date: "",
          date_issued: ""
        };

        setTimeout(() => {
  this.$router.push("/all/loans");
}, 1500);


      } catch (error) {

        if (error.response) {
          this.errorMessage = error.response.data.message;
        } else {
          this.errorMessage = "Server error";
        }

      }

      this.loading = false;

    },

    formatMoney(value) {
      return new Intl.NumberFormat().format(value);
    }

  }
};
</script>

<style scoped>

.loan-container {
  max-width: 500px;
  margin: auto;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.title {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

input, select {
  width: 100%;
  padding: 8px;
}

button {
  width: 100%;
  padding: 10px;
  background: #2c7be5;
  color: white;
  border: none;
  cursor: pointer;
}

button:hover {
  background: #1a68d1;
}

.success {
  margin-top: 15px;
  color: green;
}

.error {
  margin-top: 15px;
  color: red;
}

</style>
